import React from 'react';
import './header.css'
import Logo from './download.png'
import Bars from './bars.png';
import {useState} from 'react';
function Header() {
    const mobile = window.innerWidth <= 768 ? true : false;
    const [menuOpened, setMenuOpened] = useState(false);
    return (
        <div className='header'>
            {/* <img className='logo' src={Logo} alt="logo"/> */}
            { menuOpened=== false && mobile === true? (
            <div style={{
                backgroundColor: "transparent",
                padding: "0.5rem",
                borderRadius: "5px",
                }}
                onClick={() => setMenuOpened(true)}
            >
                <img src={Bars} alt="bars"
                style={{width:'1.5rem',height:'1.5rem'}} />
            </div>):
            (<ul className='header-menu'>
                <li onClick={()=> setMenuOpened(false)}>Home</li>
                <li onClick={()=> setMenuOpened(false)}>Price</li>
                <li onClick={()=> setMenuOpened(false)}>Converter</li>
                <li onClick={()=> setMenuOpened(false)}>Portfolio</li>
                <li onClick={()=> setMenuOpened(false)}>About us</li>
            </ul>)}

        </div>
    );
}
export default Header;            